import {PortableText} from '@portabletext/react'
import {Link} from '@tanstack/react-router'
import clsx from 'clsx'
import {Button} from '~/components/common/Button'
import Card from '~/components/common/Card'

export type TextCard = {
    _key: string
    _type: 'textCard'
    className?: string
    title?: string
    description: Array<{
        children?: Array<{
            marks?: Array<string>
            text?: string
            _type: 'span'
            _key: string
        }>
        style?: 'blockquote' | 'h2' | 'h3' | 'h4' | 'normal'
        listItem?: 'bullet' | 'number'
        markDefs?: Array<{
            href?: string
            _type: 'link'
            _key: string
        }>
        level?: number
        _type: 'block'
        _key: string
    }>
    link?: {
        label: string
        link: string
    }
}

type TextCardProps = TextCard

const TextCard = ({className, title, description, link}: TextCardProps) => {
    return (
        <div className={clsx('inline-block w-full', className)}>
            <div className="relative md:py-8">
                <div className="absolute hidden md:block backdrop-blur transform-gpu bg-gray-700/10 w-full max-w-screen-xl xl:rounded-2xl inset-x-0 mx-auto h-[calc(100%_-_4rem)]" />
                <Card className="!bg-gray-400/20 text-center !rounded-none md:!rounded-2xl p-6 md:px-8 max-w-screen-md md:mx-auto space-y-4 md:-my-8">
                    {!!title && <h2 className="text-2xl md:text-4xl font-bold">{title}</h2>}
                    <div className="space-y-2 text-sm md:text-lg">
                        <PortableText value={description} />
                    </div>
                    {!!link && (
                        <div className="flex items-center justify-center">
                            <Button as={Link} to={link.link}>
                                {link.label}
                            </Button>
                        </div>
                    )}
                </Card>
            </div>
        </div>
    )
}

export default TextCard
